// eslint-disable-next-line import/prefer-default-export
export const handlingJSON = data => {
  console.debug("handleingJSON", data);
  let supposedData = { meta: {} };
  if (data.common.type === "ADDRESS") {
    supposedData = data.common;
    supposedData.meta = { default: "" };
    if (data.meta !== undefined && Object.keys(data.meta).length !== 0) {
      supposedData.meta.default = data.meta;
    }
  } else {
    supposedData = data.common;
    supposedData.meta = data.meta;
  }
  return supposedData;
};



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/CustomDynamicFieldSelect/jsonHandling.js